import { Component } from 'react';
import PropTypes from 'prop-types';
import axios from '../../services/axiosAuth';
import Sprintf from 'sprintf-js';
import ReactDataTable, { createTheme } from 'react-data-table-component';
import qs from 'qs';
import NoData from './Parts/NoData';
import Pagination from './Parts/Pagination';
import SubHeader from './Parts/SubHeader';
import FilterFactory from './Filters/FilterFactory';
import { MATCH_TYPE_RAW_DQL } from '../../constants/filterMatchTypes';
import '../../styles/datatable.scss';
import SummaryModal from '../Modal/SummaryModal';
import TabFilters from './Filters/TabFilters';
import ActionBar from './ActionBar/ActionBar';
import { setSelectedItems } from '../../reducers/selectedItemsActions';
const urlQueryPattern = '%s?%s';
const styles = {
  headRow: {
    style: {
      backgroundColor: '#f2f7fa',
      borderRadius: '5px',
      minHeight: '45px',
      borderBottomWidth: '0',
      color: '#0e2539',
      flexShrink: '0',
    },
  },
  rows: {
    style: {
      minHeight: '70px',
    },
  },
  headCells: {
    style: {
      color: '#0e2539',
      fontSize: '14px',
      fontWeight: '400',
      paddingLeft: '8px',
      paddingRight: '8px',
      flexGrow: '1',
    },
  },
  cells: {
    style: {
      fontSize: '12px',
      paddingLeft: '8px',
      paddingRight: '8px',
      minWidth: '0px',
    },
  },
  tableWrapper: {
    style: {
      display: 'block',
    },
  },
};

const selectCriteria = (filtersValue, criteria, trigger) => {
  if (filtersValue.toConfirm && !trigger) {
    return criteria;
  }
  return false;
};
class DataTable extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: { page: 1 },
      selectedRows: [],
      loading: false,
      mounting: false,
      totalRows: 0,
      perPage: 10,
      sortColumn: props.defaultSortField,
      sortDirection: props.sortDirection,
      filtersValue: props.defaultFilters,
      filtering: false,
      summaryData: [],
      isSummaryOpen: false,
      isSummaryLoading: false,
      selectionTriggered: false,
      afterAction: false,
    };

    this.handleFilterValueChange = this.handleFilterValueChange.bind(this);
    this.handleFilter = this.handleFilter.bind(this);
    this.afterAction = this.afterAction.bind(this);
    this.rerenderParentCallback = this.rerenderParentCallback.bind(this);
  }

  async componentDidMount() {
    if (this.props.location?.userProps?.triggerToConfirm) {
      await this.handleFilterValueChange({
        target: {
          label: 'toConfirm',
          name: 'toConfirm',
          selected: true,
          value: true,
        },
      });
      await this.handleFilter();
    } else {
      this.handleFilter();
    }
  }
  // eslint-disable-next-line no-unused-vars
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.filtersValue.toConfirm === 'true' && this.state.filtering && !this.state.loading) {
      if (!this.state.selectionTriggered) {
        this.selectableTriggerHandler(true);
      }
    }
    if (this.state.filtersValue.toConfirm === '' && this.state.filtering && !this.state.loading) {
      if (this.state.selectionTriggered) {
        this.selectableTriggerHandler(false);
      }
    }
    if (this.state.afterAction) {
      this.setState({
        afterAction: false,
      });
    }
  }
  afterAction = () => {
    this.setState({ afterAction: true });
    this.handleRowSelected({ selectedRows: [] });
  };
  handlePageChange = (page) => {
    this.setState({ loading: true });
    const { perPage, sortColumn, sortDirection, filtersValue } = this.state;

    axios
      .get(
        Sprintf.sprintf(urlQueryPattern, this.props.url, this.generateQueryString(page, perPage, sortColumn, sortDirection, filtersValue))
      )
      .then((response) => {
        this.setState({
          loading: false,
          data: response.data,
          totalRows: response.data.count,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handlePerRowsChange = (perPage, page) => {
    this.setState({ loading: true });
    const { sortColumn, sortDirection, filtersValue } = this.state;

    axios
      .get(
        Sprintf.sprintf(urlQueryPattern, this.props.url, this.generateQueryString(page, perPage, sortColumn, sortDirection, filtersValue))
      )
      .then((response) => {
        this.setState({
          loading: false,
          data: response.data,
          totalRows: response.data.count,
          perPage,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleSort = (column, sortDirection) => {
    const sortColumn = column.sortParam ? column.sortParam : column.selector;

    this.setState({
      loading: true,
      sortColumn: sortColumn,
      sortDirection: sortDirection,
    });

    const { perPage, filtersValue } = this.state;
    const page = this.state.data.page;

    axios
      .get(
        Sprintf.sprintf(urlQueryPattern, this.props.url, this.generateQueryString(page, perPage, sortColumn, sortDirection, filtersValue))
      )
      .then((response) => {
        this.setState({
          loading: false,
          data: response.data,
          totalRows: response.data.count,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleFilter = (event, silent = false) => {
    this.setState({
      selectedRows: [],
    });

    if (silent) {
      this.setState({ loading: true });
    } else {
      this.setState({ loading: true, filtering: true });
    }
    const { perPage, sortColumn, sortDirection, filtersValue } = this.state;
    const page = this.state.data.page;

    axios
      .get(
        Sprintf.sprintf(urlQueryPattern, this.props.url, this.generateQueryString(page, perPage, sortColumn, sortDirection, filtersValue))
      )
      .then((response) => {
        this.setState({
          loading: false,
          data: response.data,
          totalRows: response.data.count,
        });
      })
      .catch((error) => {
        console.log(error);
        this.setState({
          loading: true,
          filtering: false,
        });
      })
      .finally(() => {
        this.setState({ filtering: false });
      });
  };

  handleFilterValueChange = (event) => {
    const target = event.target;
    const filters = this.state.filtersValue;
    let value = [target.value];
    if (this.isMultiSelect(target.value)) {
      value = target.value.map((filter) => filter.value);
    } else if (this.isSelect(target.value) && typeof target.value !== 'undefined') {
      value = [target.value.value];
    }

    this.setState({
      filtersValue: {
        ...filters,
        [target.name]: value.join(),
      },
    });
  };

  isMultiSelect = (value) => Array.isArray(value);
  isSelect = (value) => typeof value === 'object' && value !== null;

  handleExport = () => {
    const contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    const { filtersValue } = this.state;

    axios
      .get(
        Sprintf.sprintf(urlQueryPattern, this.props.url, qs.stringify(this.generateFiltersForQueryString(filtersValue))) + '&limit=0',
        {
          responseType: 'blob',
          headers: {
            'Content-Type': contentType,
            Accept: contentType,
          },
        }
      )
      .then((response) => {
        let filename = 'export.xlsx';
        // eslint-disable-next-line no-prototype-builtins
        if (response.headers.hasOwnProperty('Content-Disposition')) {
          decodeURI(response.headers.get('Content-Disposition').split('filename=')[1]);
        }

        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: contentType,
          })
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  handleSummary = () => {
    const { filtersValue } = this.state;
    this.setState({
      isSummaryOpen: true,
      isSummaryLoading: true,
    });

    axios
      .get(Sprintf.sprintf(urlQueryPattern, this.props.url, qs.stringify(this.generateFiltersForQueryString(filtersValue))))
      .then((response) => {
        this.setState({ summaryData: response.data.collection });
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        this.setState({ isSummaryLoading: false });
      });
  };

  generateQueryString = (page, perPage, sortColumn, sortDirection, filtersValue = null) => {
    let queryObject = {
      page: (page - 1) * perPage <= this.state.totalRows ? page : 1,
      limit: perPage,
    };

    if (null !== sortColumn) {
      queryObject.sort = {};
      queryObject.sort[sortColumn] = sortDirection;
    }

    if (null !== filtersValue) {
      queryObject.filter = {};
      queryObject = this.generateFiltersForQueryString(filtersValue, queryObject);
    }

    return qs.stringify(queryObject);
  };

  generateFiltersForQueryString = (filtersValue, queryObject = null) => {
    if (queryObject === null) {
      queryObject = { filter: {} };
    }

    Object.keys(filtersValue).forEach((key) => {
      if (typeof filtersValue[key] === 'undefined' || filtersValue[key] === null || filtersValue[key] === '') {
        return;
      }

      const filter = this.props.filters.filter((filter) => filter.field === key)[0];
      if (typeof filter !== 'undefined') {
        queryObject.filter[key] = {
          value:
            filter.matchType === MATCH_TYPE_RAW_DQL
              ? JSON.stringify({
                  value: filter?.expression.value,
                  parameters: {
                    [key]: filter?.expression.wildcard ? '%' + filtersValue[key] + '%' : filtersValue[key],
                  },
                  // eslint-disable-next-line no-prototype-builtins
                  leftJoin: filter.expression.hasOwnProperty('leftJoin') ? filter.expression.leftJoin : null,
                })
              : filtersValue[key].trim(),
          matchType: filter.matchType,
        };
      } else {
        const dateRange = this.props.filters.filter((filter) => {
          return (
            // eslint-disable-next-line no-prototype-builtins
            filter.hasOwnProperty('availableFields') && filter.availableFields.includes(key)
          );
        })[0];

        if (
          dateRange.availableFields.filter((el) =>
            // eslint-disable-next-line no-prototype-builtins
            queryObject.filter.hasOwnProperty(el)
          ).length > 0
        ) {
          return;
        }

        const queryParameters = {};
        const queryFilters = dateRange.collection
          .filter((dateFilter) => filtersValue[dateFilter.field])
          .map((dateFilter) => {
            queryParameters[dateFilter.field] = filtersValue[dateFilter.field];
            return dateFilter?.expression.value;
          });

        queryObject.filter[key] = {
          value: JSON.stringify({
            value: queryFilters.join(' AND '),
            parameters: queryParameters,
          }),
          matchType: MATCH_TYPE_RAW_DQL,
        };
      }
    });

    return queryObject;
  };

  handleRowSelected = (fnProps) => {
    if (this.state.data?.collection) {
      this.setState({
        selectedRows: fnProps.selectedRows,
        selectionTriggered: true,
      });
      if (fnProps.selectedRows.length !== 0) {
        this.props.dispatch(setSelectedItems(fnProps.selectedRows));
      }
    }
  };

  selectableTriggerHandler = (bool) => {
    this.setState({
      selectionTriggered: bool,
      afterAction: false,
    });
  };

  rerenderParentCallback = () => {
    this.handleFilter();
  };

  render() {
    const { loading, data, totalRows } = this.state;

    const filters = this.props.filters.map((filter) => {
      return (
        <FilterFactory
          key={filter.field}
          config={filter}
          onChange={this.handleFilterValueChange}
          value={this.state.filtersValue[filter.field]}
        />
      );
    });

    return (
      <>
        <TabFilters
          showTabFilters={this.props.tabFilters?.showTabFilters}
          options={this.props.tabFilters?.options}
          setTabFiltersOptions={this.props.tabFilters?.setTabFiltersOptions}
          handleFiltersChange={this.handleFilter}
          handleFilterValueChange={this.handleFilterValueChange}
        />
        <ReactDataTable
          {...this.props}
          data={this.props.parser(data.collection)}
          paginationTotalRows={totalRows}
          onChangePage={this.handlePageChange}
          onChangeRowsPerPage={this.handlePerRowsChange}
          onSelectedRowsChange={this.handleRowSelected}
          onSort={this.handleSort}
          clearSelectedRows={this.state.afterAction}
          paginationComponent={() => (
            <Pagination
              currentPage={this.state.data.page}
              rowCount={totalRows}
              rowsPerPage={this.state.data.limit}
              onChangePage={this.handlePageChange}
              onChangeRowsPerPage={this.handlePerRowsChange}
              onExport={this.handleExport}
              onSummary={this.handleSummary}
              isSummary={this.props.isSummary}
            />
          )}
          conditionalRowStyles={this.props.conditionalRowStyles}
          selectableRows={this.props.selectableRows}
          selectableRowDisabled={this.props.selectableRowDisabledCriteria}
          selectableRowSelected={selectCriteria(
            this.state.filtersValue,
            this.props.selectableRowSelectedCriteria,
            this.state.selectionTriggered
          )}
          noHeader={this.props.title === null}
          subHeader={typeof this.props.filters !== 'undefined' && this.props.filters.length > 0}
          subHeaderComponent={
            <SubHeader
              filtersCollection={filters}
              visibleFilters={this.props.filters.filter((f) => f.type !== 'HIDDEN')}
              onClick={this.handleFilter}
              filtering={this.state.filtering}
              reloadGrid={this.props.reloadGrid}
              renderParenCallBack={this.rerenderParentCallback}
            />
          }
          noDataComponent={this.state.mounting ? <div /> : this.props.noDataComponent}
          theme='pragma'
          customStyles={styles}
          style={loading ? { opacity: 0.5, pointerEvents: 'none' } : {}}
        />
        <ActionBar
          active={this.props.selectableRows}
          forceReloadFn={this.props.forceReloadFn}
          selectedRows={this.state.selectedRows}
          actionBarComponents={this.props.actionBarComponents}
        />
        <SummaryModal
          isOpen={this.state.isSummaryOpen}
          isSummaryLoading={this.state.isSummaryLoading}
          data={this.state.summaryData}
          onRequestClose={() => this.setState({ isSummaryOpen: false })}
        />
      </>
    );
  }
}

createTheme('pragma', {
  text: {
    primary: '#929faf',
    secondary: '#000',
  },
  background: {
    default: '#fff',
  },
  context: {
    background: '#fff',
    text: '#929faf',
  },
  divider: {
    default: '#eeefef',
  },
  button: {
    default: '#009dd7',
  },
  sortFocus: {
    default: '#009dd7',
  },
  highlightOnHover: {
    default: '#f2f7fa',
    text: '#0e2539',
  },
});

DataTable.propTypes = {
  ...ReactDataTable.propTypes,
  tabFilters: PropTypes.object,
  url: PropTypes.string.isRequired,
  columns: PropTypes.array.isRequired,
  filters: PropTypes.array.isRequired,
  defaultFilters: PropTypes.object,
  isSummary: PropTypes.bool.isRequired,
  sortDirection: PropTypes.string,
  reloadGrid: PropTypes.string,
};

DataTable.defaultProps = {
  ...ReactDataTable.defaultProps,
  title: null,
  keyField: 'id',
  striped: false,
  highlightOnHover: true,
  pointerOnHover: false,
  noDataComponent: <NoData />,
  style: null,
  responsive: false,
  disabled: false,
  noHeader: false,
  subHeader: false,
  pagination: true,
  paginationServer: true,
  sortServer: true,
  defaultSortField: null,
  persistTableHead: true,
  defaultFilters: {},
  tabFilters: {},
  sortDirection: 'DESC',
  reloadGrid: null,
};

export default DataTable;
